module.exports = __webpack_public_path__ + "images/branding/manpower/hd_bg.gif";